import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import SignupForm from "./components/signup";
import Login from "./components/login";
import ForgotPassword from "./components/forgotpassword";
import VerifyCode from "./components/verifycode";
import LoginForgotPassword from "./components/login";
import HomePage from "./components/homepage";
import ResetPassword from "./components/resetpassword";
import Auth from "./components/Auth";
import FriendsFollowers from "./components/friendsfollowers";
import VerifyCodeSignup from "./components/verifycodeforsignup";
import Ordermanagement from "./components/myorder/ordermanagement";
import OrderDetail from "./components/myorder/OrderDetail";
// import HomePageNew from "./components/homenew";
import Myprofile from "./components/profile";
import GoogleAuthCallback from "./components/googleAuth";
import Navbar from "./components/sidebar/leftsidebar";
import Groupsandfamily from "./components/groupsandfamily";
import "./index.css";
import "flowbite";
import Profileedit from "./components/profileedit";
import VerifyCodeMobile from "./components/verifycodemobile";
import Signinwithmobile from "./components/signinwithmobile";
import Golive from "./components/golive";
import GoliveDonation from "./components/golivedonation";
import Account from "./components/Account";
import { SearchProvider } from "./context/SearchContext";
import Viewpost from "./components/feedpost/viewpost";
import TermsConditions from "./components/TermsConditions";
import TermsConditionsMobile from "./components/TermsConditionsMobile";
import PrivacyPolicy from "./components/PrivacyPolicy";

import ProfileView from "./components/profileview";
import Profilefollowers from "./components/profilefollowers";
import Donation from "./components/donation";
import React, { useEffect } from "react";
import { messaging, getToken, onMessage } from "./components/firebase-config";
import AboutUsDetail from "./components/AboutUsDetail";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Elements } from "@stripe/react-stripe-js";
import FanHome from "./components/fanHome/FanHome";
import SoundDetail from "./components/soundDetail/SoundDetail";
import Search from "./components/fanHome/Search";
import Library from "./components/fanHome/Library";
import ReceiptPage from "./components/receipts/ReceiptPage";
import PlaylistPage from "./components/fanHome/PlaylistPage";
import MyRightsCases from "./components/rightsClaims/MyRightsCases";
import RightsHub from "./components/rightsClaims/RightsHub";
import RightsFormPage from "./components/rightsClaims/RightsFormPage";
import ReportAudioPage from "./components/rightsClaims/ReportAudioPage";
import CounterNoticePage from "./components/rightsClaims/CounterNoticePage";
import CommercialUse from "./components/rightsClaims/CommercialUse";
import PolicyViewer from "./components/rightsClaims/PolicyViewer";
import PublicTakedown from "./components/rightsClaims/PublicTakedown";
import PrivacyRights from "./components/rightsClaims/PrivacyRights";
import BuyerNotices from "./components/rightsClaims/BuyerNotices";
import LicencesNeeded from "./components/rightsClaims/LicencesNeeded";
import { PlayerProvider } from "./components/fanHome/PlayerContext";
import { getStripe } from "./components/common/stripeClient";
import PostDetailPage from "./components/PostDetailPage"; // 👈 create this
import DeepLinkRedirect from "./components/DeepLinkRedirect";
import ShortLinkRedirect from "./components/ShortLinkRedirect";
// import ProtectedRoute from "./components/ProtectedRoute";
import Wallet from "./components/wallet";
import SubscriptionPage from "./components/subscription/SubscriptionPage";
import PastLives from "./components/subscription/PastLives";
import AboutUs from "./components/AboutUs";
import Help from "./components/Help";
import SellerInformation from "./components/sellerInformation/SellerInformation";
import Profile from "./components/SellProfile/Profile";
import Buyer from "./components/shopbuye/Buyer";
import Buyers from "./components/shopbuyeformarketplace/Buyer";

import Seller from "./components/becomesell/Seller";
import LiveShopping from "./components/becomesell/LiveShopping";
import CustomView from "./components/customshop/CustomView";
import FundPage from "./components/fundraiseing/FundPage";
import NotificationPage from "./components/notification/NotificationPage";
import StoryBar from "./components/story/StoryBar";
import DonationPage from "./components/donation";
import ProtectedRoute from "./components/common/ProtectedRoute";
import SelectInterests from "./components/SelectInterests";
import PublicRoute from "./components/common/PublicRoute";
import ChatsPage from "./components/common/ChatsPage";
import ArtistApplication from "./components/artistStudio/ArtistApplication";
import ArtistProfilePage from "./components/artistStudio/ArtistProfilePage";
import RightsHolders from "./components/artistStudio/RightsHolders";
import RightsLegal from "./components/artistStudio/RightsLegal";
import DeactivateAccount from "./components/artistStudio/DeactivateAccount";
import PublicArtistProfile from "./components/artistStudio/PublicArtistProfile";
import FanMembershipPlans from "./components/fanMembership/FanMembershipPlans";
import FanMembershipCheckout from "./components/fanMembership/FanMembershipCheckout";
import FanMembershipDetails from "./components/fanMembership/FanMembershipDetails";
import MyPlan from "./components/fanMembership/MyPlan";
import FanPreferences from "./components/fanMembership/FanPreferences";
import PaymentMethods from "./components/fanMembership/PaymentMethods";
import PurchaseHistory from "./components/fanMembership/PurchaseHistory";
import PublicPageSettings from "./components/artistStudio/PublicPageSettings";
import TrackList from "./components/artistStudio/TrackList";
import TrackUpload from "./components/artistStudio/TrackUpload";
import TrackDetail from "./components/artistStudio/TrackDetail";
import Monetization from "./components/artistStudio/Monetization";
import UsageLog from "./components/artistStudio/UsageLog";
import MusicWallet from "./components/artistStudio/MusicWallet";
import TaxForm from "./components/artistStudio/TaxForm";
import PayoutHistory from "./components/artistStudio/PayoutHistory";
import RoyaltyStatements from "./components/artistStudio/RoyaltyStatements";
import MonthlyStatements from "./components/artistStudio/MonthlyStatements";
import NotificationPreferences from "./components/artistStudio/NotificationPreferences";
import PayoutMethod from "./components/artistStudio/PayoutMethod";
import FanFunding from "./components/artistStudio/FanFunding";
import AudioReplacementReview from "./components/artistStudio/AudioReplacementReview";
import StudioDashboard from "./components/artistStudio/StudioDashboard";
import ArtistAwards from "./components/artistStudio/ArtistAwards";
import { SocketProvider } from "./contexts/SocketContext";
import { GoliveProduct } from "./components/becomesell/GoliveProduct";
import Checkout from "./components/becomesell/Checkout";
import ShopperAdders from "./components/becomesell/ShopperAdders";
import OrderReceipt from "./components/becomesell/OrderReceipt";
import PaymentFail from "./components/becomesell/PaymentFail";
import BuySellerView from "./components/becomesell/BuySellerView";
import Bcomeseller from "./components/sellerInformation/Bcomeseller";
import JoinLive from "./components/JoinLive";
import JoinLivePage from "./components/JoinLivePage";
import MarketPage from "./components/marketplace/MarketPage";
import ShopPage from "./components/shopeing/ShopPage";
import CartPage from "./components/shopeing/CartPage";
import CartPageSeller from "./components/shoppingbuyer/CartPage";

import ProductView from "./components/shopeing/ProductView";
import OrderReviewPage from "./components/ordereview/OrderReviewPage";
import OrderPage from "./components/myorder/OrderPage";
import AllSellersPage from "./components/marketplace/AllSellersPage";
import UserOrders from "./components/myorder/UserOrders";
import AdCampaignManager from "./components/ads/AdCampaignManager";
import AdAccountTypeSelect from "./components/ads/AdAccountTypeSelect";
import AddAdAccount from "./components/ads/AddAdAccount";
import CreateAdCampaign from "./components/ads/CreateAdCampaign";
import AdSubmittedSuccess from "./components/ads/AdSubmittedSuccess";
import ViewCampaign from "./components/ads/ViewCampaign";
import EditCampaign from "./components/ads/EditCampaign";
import ViewAdSet from "./components/ads/ViewAdSet";
import EditAdSetPage from "./components/ads/EditAdSetPage";
import ViewAd from "./components/ads/ViewAd";
import EditAd from "./components/ads/EditAd";
import CreateAdSetPage from "./components/ads/CreateAdSetPage";
import CreateAdPage from "./components/ads/CreateAdPage";
import AdBillingDashboard from "./components/ads/billing/AdBillingDashboard";
import AdBillingModel from "./components/ads/billing/AdBillingModel";
import AdTaxBillingInfo from "./components/ads/billing/AdTaxBillingInfo";
import AdAddCredits from "./components/ads/billing/AdAddCredits";
import AdPaymentMethods from "./components/ads/billing/AdPaymentMethods";
import AdInvoices from "./components/ads/billing/AdInvoices";
import AdPayInvoice from "./components/ads/billing/AdPayInvoice";
import AdSpendingControls from "./components/ads/billing/AdSpendingControls";
import AdPostpaidSetup from "./components/ads/billing/AdPostpaidSetup";
export default function App() {
  useEffect(() => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker
        .register("/firebase-messaging-sw.js")
        .then((registration) => {
          console.log("✅ Service Worker registered");

          Notification.requestPermission().then((permission) => {
            if (permission === "granted") {
              getToken(messaging, {
                vapidKey:
                  "BM4Lm-Z02wa63w6mLl_5mmGANpi02V_x4tQqqKIQqtEOjHFymNn7-NoRb5-312kiIyOBD6gcXM5rSH7ZIyLd4mU",
                serviceWorkerRegistration: registration, // ✅ important
              })
                .then((currentToken) => {
                  if (currentToken) {
                    console.log("✅ FCM Token:", currentToken);
                    // Send to backend if needed
                  } else {
                    console.warn("⚠️ No registration token available.");
                  }
                })
                .catch((err) => {
                  console.error("❌ Error retrieving token:", err);
                });
            }
          });

          // Foreground messages
          onMessage(messaging, (payload) => {
            console.log("📩 Foreground message received:", payload);
            alert(
              `${payload.notification.title}: ${payload.notification.body}`,
            );
          });
        })
        .catch((err) => {
          console.error("❌ Service Worker registration failed:", err);
        });
    }
  }, []);
  const streamId = "stream_1761132073103_c63c5263996a6b51";

  const stripePromise = getStripe(); // key comes from REACT_APP_STRIPE_PUBLISHABLE_KEY (see common/stripeClient.js)

  return (
    <SearchProvider>
      <Router>
        <PlayerProvider>
        <div className="flex flex-col items-center justify-center min-h-screen">
          {/* <h1 className="text-3xl font-bold text-gray-700 mb-6">Welcome</h1> */}
          <div className="flex space-x-4">
            {/* <Link to="/login" className="bg-blue-500 text-white px-6 py-2 rounded-lg hover:bg-blue-600">
              Login
            </Link>
            <Link to="/signup" className="bg-green-500 text-white px-6 py-2 rounded-lg hover:bg-green-600">
              Signup
            </Link> */}
          </div>
          <Routes>
            <Route
              path="/"
              element={
                <PublicRoute>
                  <Login />
                </PublicRoute>
              }
            />

            <Route path="/signup" element={<SignupForm />} />

            <Route
              path="/login"
              element={
                // <ProtectedRoute>
                <Login />
                // </ProtectedRoute>
              }
            />
            <Route path="/forgotpassword" element={<ForgotPassword />} />
            <Route path="/verifycode" element={<VerifyCode />} />
            <Route path="/login" element={<LoginForgotPassword />} />
            {/* <Route path="/post/:id" element={<PostDetailPage />} /> */}
            {/* For stories */}
            <Route path="/story/:id" element={<StoryBar />} />

            {/* For donations */}
            {/* <Route path="/donation/:id" element={<DonationPage />} /> */}
            <Route
              path="/home"
              element={
                <Elements stripe={stripePromise}>
                  <ProtectedRoute>
                    <HomePage />
                  </ProtectedRoute>
                </Elements>
              }
            />
            {/* Fan Home Page: music discovery and playback. Open to guests (Trending, Recommended); signed-in fans also see their own sections. */}
            <Route path="/fan/home" element={<FanHome />} />
            {/* Search and Discovery, My Library (saved sounds, playlists, licences) and one playlist. */}
            <Route path="/fan/search" element={<Search />} />
            <Route path="/fan/library" element={<Library />} />
            <Route path="/fan/plan" element={<ProtectedRoute><MyPlan /></ProtectedRoute>} />
            <Route path="/fan/preferences" element={<ProtectedRoute><FanPreferences /></ProtectedRoute>} />
            <Route path="/fan/payment-methods" element={<ProtectedRoute><PaymentMethods /></ProtectedRoute>} />
            <Route path="/fan/purchases" element={<ProtectedRoute><PurchaseHistory /></ProtectedRoute>} />
            <Route path="/fan/playlists/:id" element={<PlaylistPage />} />
            {/* Receipt and invoice (PDF download) for a paid membership or licence: /receipts/membership/12, /receipts/licence/7 */}
            <Route path="/receipts/:type/:id" element={<ProtectedRoute><ReceiptPage /></ProtectedRoute>} />
            {/* My cases: copyright notices, counter-notices and ownership disputes the user filed or received. */}
            <Route path="/rights-cases" element={<MyRightsCases />} />
            {/* Rights & legal hub for fans: report a sound, commercial-use info, policies. */}
            <Route path="/rights" element={<RightsHub />} />
            <Route path="/rights/notice" element={<RightsFormPage kind="notice" />} />
            <Route path="/rights/dispute" element={<RightsFormPage kind="dispute" />} />
            <Route path="/rights/report-audio" element={<ReportAudioPage />} />
            <Route path="/rights/counter-notice" element={<CounterNoticePage />} />
            <Route path="/rights/commercial-use" element={<CommercialUse />} />
            <Route path="/rights/takedown" element={<PublicTakedown />} />
            <Route path="/rights/privacy-request" element={<ProtectedRoute><PrivacyRights /></ProtectedRoute>} />
            <Route path="/rights/notices" element={<ProtectedRoute><BuyerNotices /></ProtectedRoute>} />
            <Route path="/rights/licences-needed" element={<ProtectedRoute><LicencesNeeded /></ProtectedRoute>} />
            <Route path="/rights/policies/:slug" element={<PolicyViewer />} />
            {/* Sound Detail Page: playback, playlist, download, licences and videos using the sound. Open to guests. */}
            <Route path="/sound/:id" element={<SoundDetail />} />
            {/* Fan Page Membership: Choose your plan, then checkout (card payment through Stripe) */}
            <Route
              path="/fan-membership"
              element={
                <ProtectedRoute>
                  <FanMembershipPlans />
                </ProtectedRoute>
              }
            />
            <Route
              path="/fan-membership/details"
              element={
                <ProtectedRoute>
                  <FanMembershipDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/fan-membership/checkout"
              element={
                <Elements stripe={stripePromise}>
                  <ProtectedRoute>
                    <FanMembershipCheckout />
                  </ProtectedRoute>
                </Elements>
              }
            />
            <Route
              path="/select-interests"
              element={
                <ProtectedRoute>
                  <SelectInterests />
                </ProtectedRoute>
              }
            />
            <Route
              path="/post/:id"
              element={
                <Elements stripe={stripePromise}>
                  <ProtectedRoute>
                    <HomePage />
                  </ProtectedRoute>
                </Elements>
              }
            />
            <Route
              path="/donation/:id"
              element={
                <Elements stripe={stripePromise}>
                  <ProtectedRoute>
                    <HomePage />
                  </ProtectedRoute>
                </Elements>
              }
            />
            {/* <Route path="/chats" element={<ChatsPage  />} /> */}
            <Route
              path="/chats"
              element={
                <ProtectedRoute>
                  <SocketProvider>
                    <ChatsPage />
                  </SocketProvider>
                </ProtectedRoute>
              }
            />
            <Route
              path="/wallet"
              element={
                <Elements stripe={stripePromise}>
                  <ProtectedRoute>
                    <Wallet />
                  </ProtectedRoute>
                </Elements>
              }
            />
            <Route
              path="/subscription"
              element={
                <Elements stripe={stripePromise}>
                  <ProtectedRoute>
                    <SubscriptionPage />
                  </ProtectedRoute>
                </Elements>
              }
            />
            <Route
              path="/past-lives"
              element={
                <ProtectedRoute>
                  <PastLives />
                </ProtectedRoute>
              }
            />
            <Route
              path="/artist-studio"
              element={
                <ProtectedRoute>
                  <ArtistApplication />
                </ProtectedRoute>
              }
            />
            <Route
              path="/artist-studio/verification"
              element={
                <ProtectedRoute>
                  <ArtistApplication verificationPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/artist-studio/profile"
              element={
                <ProtectedRoute>
                  <ArtistProfilePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/artist-studio/rights"
              element={
                <ProtectedRoute>
                  <RightsLegal tab="strikes" />
                </ProtectedRoute>
              }
            />
            <Route
              path="/artist-studio/rights/notices"
              element={
                <ProtectedRoute>
                  <RightsLegal tab="notices" />
                </ProtectedRoute>
              }
            />
            <Route
              path="/artist-studio/rights/claims"
              element={
                <ProtectedRoute>
                  <RightsLegal tab="claims" />
                </ProtectedRoute>
              }
            />
            <Route
              path="/artist-studio/rights/terms"
              element={
                <ProtectedRoute>
                  <RightsLegal tab="terms" />
                </ProtectedRoute>
              }
            />
            <Route
              path="/artist-studio/rights/holders"
              element={
                <ProtectedRoute>
                  <RightsHolders />
                </ProtectedRoute>
              }
            />
            <Route
              path="/artist-studio/deactivate"
              element={
                <ProtectedRoute>
                  <DeactivateAccount />
                </ProtectedRoute>
              }
            />
            <Route
              path="/artist-studio/public-page"
              element={
                <ProtectedRoute>
                  <PublicPageSettings />
                </ProtectedRoute>
              }
            />
            <Route
              path="/artist-studio/fan-funding"
              element={
                <ProtectedRoute>
                  <FanFunding />
                </ProtectedRoute>
              }
            />
            <Route
              path="/artist-studio/awards"
              element={
                <ProtectedRoute>
                  <ArtistAwards />
                </ProtectedRoute>
              }
            />
            <Route
              path="/artist-studio/dashboard"
              element={
                <ProtectedRoute>
                  <StudioDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/artist-studio/tracks"
              element={
                <ProtectedRoute>
                  <TrackList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/artist-studio/monetization"
              element={
                <ProtectedRoute>
                  <Monetization />
                </ProtectedRoute>
              }
            />
            <Route
              path="/moderation/audio-replacements"
              element={
                <ProtectedRoute>
                  <AudioReplacementReview />
                </ProtectedRoute>
              }
            />
            <Route
              path="/artist-studio/monetization/usage-log"
              element={
                <ProtectedRoute>
                  <UsageLog />
                </ProtectedRoute>
              }
            />
            <Route
              path="/artist-studio/wallet"
              element={
                <ProtectedRoute>
                  <MusicWallet />
                </ProtectedRoute>
              }
            />
            <Route
              path="/artist-studio/wallet/tax"
              element={
                <ProtectedRoute>
                  <TaxForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/artist-studio/wallet/payout-method"
              element={
                <ProtectedRoute>
                  <PayoutMethod />
                </ProtectedRoute>
              }
            />
            <Route
              path="/artist-studio/notifications"
              element={
                <ProtectedRoute>
                  <NotificationPreferences />
                </ProtectedRoute>
              }
            />
            <Route
              path="/artist-studio/wallet/statements"
              element={
                <ProtectedRoute>
                  <RoyaltyStatements />
                </ProtectedRoute>
              }
            />
            <Route
              path="/artist-studio/wallet/monthly-statements"
              element={
                <ProtectedRoute>
                  <MonthlyStatements />
                </ProtectedRoute>
              }
            />
            <Route
              path="/artist-studio/wallet/payouts"
              element={
                <ProtectedRoute>
                  <PayoutHistory />
                </ProtectedRoute>
              }
            />
            <Route
              path="/artist-studio/tracks/:id/view"
              element={
                <ProtectedRoute>
                  <TrackDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/artist-studio/tracks/:id"
              element={
                <ProtectedRoute>
                  <TrackUpload />
                </ProtectedRoute>
              }
            />
            {/* Visitor-facing: deliberately NOT behind ProtectedRoute (no login needed) */}
            <Route path="/artists/:slug" element={<Elements stripe={stripePromise}><PublicArtistProfile /></Elements>} />
            <Route path="/resetpassword" element={<ResetPassword />} />
            <Route path="/auth" element={<Auth />} />
            <Route
              path="/friendsfollowers"
              element={
                <ProtectedRoute>
                  <FriendsFollowers />
                </ProtectedRoute>
              }
            />
            <Route
              path="/verifycodeforsignup"
              element={
                // <ProtectedRoute>
                <VerifyCodeSignup />
                // </ProtectedRoute>
              }
            />
            {/* <Route path="/homenew" element={<HomePageNew />} /> */}
            <Route
              path="/myprofile"
              element={
                <Elements stripe={stripePromise}>
                  <ProtectedRoute>
                    <Myprofile />
                  </ProtectedRoute>
                </Elements>
              }
            />
            <Route
              path="/navbar"
              element={
                <ProtectedRoute>
                  <Navbar />
                </ProtectedRoute>
              }
            />
            <Route
              path="/auth/callback"
              element={
                <ProtectedRoute>
                  <GoogleAuthCallback />
                </ProtectedRoute>
              }
            />
            <Route
              path="/signtest"
              element={
                <ProtectedRoute>
                  <GoogleAuthCallback />
                </ProtectedRoute>
              }
            />
            <Route
              path="/verifycodemobile"
              element={
                // <ProtectedRoute>
                <VerifyCodeMobile />
                // </ProtectedRoute>
              }
            />
            <Route
              path="/myprofileedit"
              element={
                <ProtectedRoute>
                  <Profileedit />
                </ProtectedRoute>
              }
            />
            <Route
              path="/groupsfamily"
              element={
                <ProtectedRoute>
                  <SocketProvider>
                    <Groupsandfamily />
                  </SocketProvider>
                </ProtectedRoute>
              }
            />
            <Route
              path="/signinwithmobile"
              element={
                // <ProtectedRoute>
                <Signinwithmobile />
                // </ProtectedRoute>
              }
            />
            <Route path="/my-orders" element={<UserOrders />} />
            <Route path="/order/:id" element={<OrderDetail />} />
            <Route
              path="/account"
              element={
                <Elements stripe={stripePromise}>
                  <ProtectedRoute>
                    <Account />
                  </ProtectedRoute>
                </Elements>
              }
            />
            <Route
              path="/golive"
              element={
                <ProtectedRoute>
                  <Golive />
                </ProtectedRoute>
              }
            />
            <Route
              path="/golivedonation"
              element={
                <Elements stripe={stripePromise}>
                  <ProtectedRoute>
                    <GoliveDonation />
                  </ProtectedRoute>
                </Elements>
              }
            />
            {/* <JoinLive streamId={streamId} /> */}
            <Route
              path="/joinlive/:streamId"
              element={
                <ProtectedRoute>
                  <JoinLive />
                </ProtectedRoute>
              }
            />
            <Route
              path="/joinlive/:streamId"
              element={
                <ProtectedRoute>
                  <JoinLivePage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/viewpost"
              element={
                <ProtectedRoute>
                  <Viewpost />
                </ProtectedRoute>
              }
            />
            <Route path="/terms-conditions" element={<TermsConditions />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route
              path="/terms-conditions-mobile"
              element={<TermsConditionsMobile />}
            />

            <Route
              path="/myprofile/:id"
              element={
                <ProtectedRoute>
                  <ProfileView />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile/:id"
              element={
                <ProtectedRoute>
                  <ProfileView />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profilefollowers"
              element={
                <ProtectedRoute>
                  <Profilefollowers />
                </ProtectedRoute>
              }
            />
            <Route
              path="/donation"
              element={
                <Elements stripe={stripePromise}>
                  <ProtectedRoute>
                    <Donation />
                  </ProtectedRoute>
                </Elements>
              }
            />
            <Route
              path="/aboutus"
              element={
                <ProtectedRoute>
                  <AboutUs />
                </ProtectedRoute>
              }
            />
            <Route
              path="/about-us-detail"
              element={
                <ProtectedRoute>
                  <AboutUsDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/help"
              element={
                <ProtectedRoute>
                  <Help />
                </ProtectedRoute>
              }
            />

            <Route
              path="/becomeaseller"
              element={
                <ProtectedRoute>
                  <Bcomeseller />
                </ProtectedRoute>
              }
            />

            <Route
              path="/sellerInformation"
              element={
                <ProtectedRoute>
                  <SellerInformation />
                </ProtectedRoute>
              }
            />
            <Route
              path="/sellprofile"
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              }
            />
            <Route
              path="/adminseller"
              element={
                <ProtectedRoute>
                  <Seller />
                </ProtectedRoute>
              }
            />
            <Route
              path="/live-shopping/:streamId"
              element={
                <ProtectedRoute>
                  <LiveShopping />
                </ProtectedRoute>
              }
            />
            <Route
              path="/buybellerview"
              element={
                <ProtectedRoute>
                  <BuySellerView />
                </ProtectedRoute>
              }
            />

            <Route
              path="/goliveseller"
              element={
                <ProtectedRoute>
                  <GoliveProduct />
                </ProtectedRoute>
              }
            />

            <Route
              path="/addshopperadders"
              element={
                <ProtectedRoute>
                  <ShopperAdders />
                </ProtectedRoute>
              }
            />

            <Route
              path="/addshopperaddress"
              element={
                <ProtectedRoute>
                  <ShopperAdders />
                </ProtectedRoute>
              }
            />
            <Route
              path="/marketplace"
              element={
                <ProtectedRoute>
                  <MarketPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/shoppage"
              element={
                <ProtectedRoute>
                  <ShopPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cart"
              element={
                <ProtectedRoute>
                  <CartPage />
                </ProtectedRoute>
              }
            />
            <Route path="/allsellers" element={<AllSellersPage />} />

            <Route
              path="/cartpageseller"
              element={
                <ProtectedRoute>
                  <CartPageSeller />
                </ProtectedRoute>
              }
            />
            <Route
              path="/productview"
              element={
                <ProtectedRoute>
                  <ProductView />
                </ProtectedRoute>
              }
            />
            <Route path="/ProductView/:id" element={<ProductView />} />
            <Route
              path="/profilecheckout"
              element={
                <ProtectedRoute>
                  <Checkout />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ordereview"
              element={
                <Elements stripe={stripePromise}>
                  <ProtectedRoute>
                    <OrderReviewPage />
                  </ProtectedRoute>
                </Elements>
              }
            />

            <Route
              path="/orderReceipt"
              element={
                <ProtectedRoute>
                  <OrderReceipt />
                </ProtectedRoute>
              }
            />

            <Route
              path="/paymentfail"
              element={
                <ProtectedRoute>
                  <PaymentFail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/myorder"
              element={
                <ProtectedRoute>
                  <OrderPage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/shpebuye"
              element={
                <ProtectedRoute>
                  <Buyer />
                </ProtectedRoute>
              }
            />
            <Route
              path="/shopbuyeformarketplace"
              element={
                <ProtectedRoute>
                  <Buyers />
                </ProtectedRoute>
              }
            />
            <Route
              path="/customview"
              element={
                <ProtectedRoute>
                  <CustomView />
                </ProtectedRoute>
              }
            />
            <Route
              path="/fundraiseing"
              element={
                <ProtectedRoute>
                  <FundPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Notification"
              element={
                <ProtectedRoute>
                  <NotificationPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ordermanagement"
              element={
                <ProtectedRoute>
                  <Ordermanagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/stream/:streamId"
              element={
                <Elements stripe={stripePromise}>
                  <ProtectedRoute>
                    <GoliveDonation viewerMode={true} />
                  </ProtectedRoute>
                </Elements>
              }
            />

            <Route
              path="/ads"
              element={
                <ProtectedRoute>
                  <AdCampaignManager />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ads/billing"
              element={
                <ProtectedRoute>
                  <AdBillingDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ads/billing/model"
              element={
                <ProtectedRoute>
                  <AdBillingModel />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ads/billing/tax-profile"
              element={
                <ProtectedRoute>
                  <AdTaxBillingInfo />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ads/billing/add-credits"
              element={
                <Elements stripe={stripePromise}>
                  <ProtectedRoute>
                    <AdAddCredits />
                  </ProtectedRoute>
                </Elements>
              }
            />
            <Route
              path="/ads/billing/payment-methods"
              element={
                <Elements stripe={stripePromise}>
                  <ProtectedRoute>
                    <AdPaymentMethods />
                  </ProtectedRoute>
                </Elements>
              }
            />
            <Route
              path="/ads/billing/invoices"
              element={
                <ProtectedRoute>
                  <AdInvoices />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ads/billing/invoices/:invoiceId/pay"
              element={
                <Elements stripe={stripePromise}>
                  <ProtectedRoute>
                    <AdPayInvoice />
                  </ProtectedRoute>
                </Elements>
              }
            />
            <Route
              path="/ads/billing/spending-controls"
              element={
                <ProtectedRoute>
                  <AdSpendingControls />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ads/billing/postpaid-setup"
              element={
                <ProtectedRoute>
                  <AdPostpaidSetup />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ads/select-account"
              element={
                <ProtectedRoute>
                  <AdAccountTypeSelect />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ads/add-account"
              element={
                <ProtectedRoute>
                  <AddAdAccount />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ads/create"
              element={
                <ProtectedRoute>
                  <CreateAdCampaign />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ads/submitted-success"
              element={
                <ProtectedRoute>
                  <AdSubmittedSuccess />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ads/campaigns/:campaignId"
              element={
                <ProtectedRoute>
                  <ViewCampaign />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ads/campaigns/:campaignId/ad-sets/new"
              element={
                <ProtectedRoute>
                  <CreateAdSetPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ads/campaigns/:campaignId/edit"
              element={
                <ProtectedRoute>
                  <EditCampaign />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ads/ad-sets/:adSetId"
              element={
                <ProtectedRoute>
                  <ViewAdSet />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ads/ad-sets/:adSetId/ads/new"
              element={
                <ProtectedRoute>
                  <CreateAdPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ads/ad-sets/:adSetId/edit"
              element={
                <ProtectedRoute>
                  <EditAdSetPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ads/ads/:adId"
              element={
                <ProtectedRoute>
                  <ViewAd />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ads/ads/:adId/edit"
              element={
                <ProtectedRoute>
                  <EditAd />
                </ProtectedRoute>
              }
            />

            {/* You can add a Login component here later */}
          </Routes>
        </div>
        </PlayerProvider>
      </Router>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </SearchProvider>
  );
}
